module.exports = __webpack_public_path__ + "static/media/Договір публічної оферти_МеДіС.b4ae86ce.pdf";